import React, { Component } from 'react';

export class Select extends Component {
    displayName = Select.name

    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            message: 'This field is required'
        }

        this.validate = this.validate.bind(this);
    }

    checkForm() {
        return this.validate(this.select.current, true);
    }

    validate(event) {
        event = event.target || event;
        var e = event.value;
        var hasError = false;
        if (this.props.required) {
            if (this.props.defaultOptionValue === e) {
                hasError = true;
            } 
        }

        this.setState({
            hasError: hasError
        }, () => { this.props.isValid(!hasError) });

        return !hasError;
    }

    render() {
        return (
            <div className={this.props.wrapperClass}>
                <select value={this.props.value}
                    ref={this.select = React.createRef()}
                onChange={(e) => { this.props.onChange(e) }}
                onBlur={(e) => this.validate(e)}
                className={"form-control " + (this.state.hasError ? "error" : "")}>
                {
                    (this.props.defaultOption != null && this.props.defaultOptionValue != null) &&
                    <option value={this.props.defaultOptionValue}>{this.props.defaultOption}</option>
                }
                    {this.props.children}
                </select>
                {
                    this.state.hasError &&
                    <div className="ErrorContainer">
                        <div className="error">{this.state.message}</div>
                    </div>
                }
            </div>
        );
    }
}

Select.defaultProps = {
    onChange: () => { },
    required: false,
    wrapperClass: "form-group",
    value: "",
    isValid: (e) => { },
    defaultOption: null,
    defaultOptionValue: 0
}


// WEBPACK FOOTER //
// ./src/components/Select.js